import { Menu } from "@/contexts/SidebarContext";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface MenuPage {
  userId: number | null; //userId
  role: string | null; //role, ex: user, admin...
  menus: Menu[]; //list menu sidebar
}
export const initialState: MenuPage = {
  userId: null,
  role: null,
  menus: []
};

const MenusSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {
    setMenus: (state, action: PayloadAction<Menu[]>) => {
      state.menus = action.payload;
    },
    //push list menu. use when user call api get groups and generate new menus with new list dashboard path
    pushMenuList: (state, action: PayloadAction<Menu[]>) => {
      state.menus = action.payload;
    },
    // clear menu list
    clearMenuList: (state) => {
      state.menus = [];
    }
  }
});

export const { pushMenuList, clearMenuList } = MenusSlice.actions;
export default MenusSlice.reducer;
